import { CircularProgress, ThemeProvider, createTheme, Box } from '@mui/material'

export const CircularProgressContinuousTheme = createTheme({
  palette: {
    primary: {
      main: '#2A49FF', // brand-500
    },
  },
})

// A spinning loader designed to fit into a tailwind ui button
export const CircularProgressContinuous = () => {
  return (
    <>
      <div className={''}>
        <div role="status" className="relative block h-[25px] pl-[5px]">
          <div className={'absolute z-0'}>
            <ThemeProvider theme={CircularProgressContinuousTheme}>
              <CircularProgress size={25} thickness={5} />
            </ThemeProvider>
          </div>
        </div>
      </div>
    </>
  )
}

// A spinning loader for custom sizing containers
type CircularProgressContinuousSizedProps = {
  size: number
  thickness: number
  hexColor?: string // e.g. '#2A49FF'
  className?: string
  showTrack?: boolean // if true, shows a grey background circle behind the spinner
}

export const CircularProgressContinuousSized = (props: CircularProgressContinuousSizedProps) => {
  const { size, thickness, hexColor = '#2A49FF', className = '', showTrack = false } = props

  const theme = createTheme({
    palette: {
      primary: {
        main: hexColor,
      },
    },
  })

  return (
    <ThemeProvider theme={theme}>
      {showTrack ? (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          {/* Grey background circle */}
          <CircularProgress variant="determinate" value={100} size={size} thickness={thickness} sx={{ color: '#D0D0D0' }} />
          {/* Foreground spinner */}
          <CircularProgress
            size={size}
            thickness={thickness}
            className={className}
            sx={{
              position: 'absolute',
              left: 0,
            }}
          />
        </Box>
      ) : (
        <CircularProgress size={size} thickness={thickness} className={className} />
      )}
    </ThemeProvider>
  )
}
